
// @ts-nocheck
import locale_BookingFormComponents_46json_9730926e from "#nuxt-i18n/9730926e";
import locale_ExpandableText_46json_04d10bd0 from "#nuxt-i18n/04d10bd0";
import locale_ModalVykradeni2_46json_da43a10b from "#nuxt-i18n/da43a10b";
import locale_SectionPricing_46json_f8d4e8ef from "#nuxt-i18n/f8d4e8ef";
import locale_SectionServices_46json_74e43e02 from "#nuxt-i18n/74e43e02";
import locale_TheFooter_46json_48fe78b5 from "#nuxt-i18n/48fe78b5";
import locale_TheHeader_46json_21b22ab2 from "#nuxt-i18n/21b22ab2";
import locale_indexPage_46json_8e8d7ccb from "#nuxt-i18n/8e8d7ccb";
import locale_nuslePage_46json_39a16fe2 from "#nuxt-i18n/39a16fe2";
import locale_zizkovPage_46json_d2c63485 from "#nuxt-i18n/d2c63485";
import locale_sluzbyPage_46json_2dae55a8 from "#nuxt-i18n/2dae55a8";
import locale_errorPage_46json_bdf1ee8f from "#nuxt-i18n/bdf1ee8f";
import locale_teamData_46json_f982453f from "#nuxt-i18n/f982453f";
import locale_products_46json_8a4797e0 from "#nuxt-i18n/8a4797e0";
import locale_gdpr_46json_6fe176b0 from "#nuxt-i18n/6fe176b0";
import locale_giftCardsPage_46json_6494f13b from "#nuxt-i18n/6494f13b";
import locale_BookingFormComponents_46json_1da4f8c5 from "#nuxt-i18n/1da4f8c5";
import locale_ExpandableText_46json_ea0c6621 from "#nuxt-i18n/ea0c6621";
import locale_ModalVykradeni2_46json_d1bd3696 from "#nuxt-i18n/d1bd3696";
import locale_SectionPricing_46json_51f08b8e from "#nuxt-i18n/51f08b8e";
import locale_SectionServices_46json_d0eeff76 from "#nuxt-i18n/d0eeff76";
import locale_TheFooter_46json_5c91eaab from "#nuxt-i18n/5c91eaab";
import locale_TheHeader_46json_ab33f711 from "#nuxt-i18n/ab33f711";
import locale_indexPage_46json_4d55f150 from "#nuxt-i18n/4d55f150";
import locale_nuslePage_46json_84c28f0a from "#nuxt-i18n/84c28f0a";
import locale_zizkovPage_46json_85f0a4d3 from "#nuxt-i18n/85f0a4d3";
import locale_sluzbyPage_46json_57c4b699 from "#nuxt-i18n/57c4b699";
import locale_errorPage_46json_c76f7484 from "#nuxt-i18n/c76f7484";
import locale_teamData_46json_abd8810e from "#nuxt-i18n/abd8810e";
import locale_products_46json_122c7ed6 from "#nuxt-i18n/122c7ed6";
import locale_gdpr_46json_92247e5d from "#nuxt-i18n/92247e5d";
import locale_giftCardsPage_46json_812e0e41 from "#nuxt-i18n/812e0e41";

export const localeCodes =  [
  "cs",
  "en"
]

export const localeLoaders = {
  cs: [
    {
      key: "locale_BookingFormComponents_46json_9730926e",
      load: () => Promise.resolve(locale_BookingFormComponents_46json_9730926e),
      cache: true
    },
    {
      key: "locale_ExpandableText_46json_04d10bd0",
      load: () => Promise.resolve(locale_ExpandableText_46json_04d10bd0),
      cache: true
    },
    {
      key: "locale_ModalVykradeni2_46json_da43a10b",
      load: () => Promise.resolve(locale_ModalVykradeni2_46json_da43a10b),
      cache: true
    },
    {
      key: "locale_SectionPricing_46json_f8d4e8ef",
      load: () => Promise.resolve(locale_SectionPricing_46json_f8d4e8ef),
      cache: true
    },
    {
      key: "locale_SectionServices_46json_74e43e02",
      load: () => Promise.resolve(locale_SectionServices_46json_74e43e02),
      cache: true
    },
    {
      key: "locale_TheFooter_46json_48fe78b5",
      load: () => Promise.resolve(locale_TheFooter_46json_48fe78b5),
      cache: true
    },
    {
      key: "locale_TheHeader_46json_21b22ab2",
      load: () => Promise.resolve(locale_TheHeader_46json_21b22ab2),
      cache: true
    },
    {
      key: "locale_indexPage_46json_8e8d7ccb",
      load: () => Promise.resolve(locale_indexPage_46json_8e8d7ccb),
      cache: true
    },
    {
      key: "locale_nuslePage_46json_39a16fe2",
      load: () => Promise.resolve(locale_nuslePage_46json_39a16fe2),
      cache: true
    },
    {
      key: "locale_zizkovPage_46json_d2c63485",
      load: () => Promise.resolve(locale_zizkovPage_46json_d2c63485),
      cache: true
    },
    {
      key: "locale_sluzbyPage_46json_2dae55a8",
      load: () => Promise.resolve(locale_sluzbyPage_46json_2dae55a8),
      cache: true
    },
    {
      key: "locale_errorPage_46json_bdf1ee8f",
      load: () => Promise.resolve(locale_errorPage_46json_bdf1ee8f),
      cache: true
    },
    {
      key: "locale_teamData_46json_f982453f",
      load: () => Promise.resolve(locale_teamData_46json_f982453f),
      cache: true
    },
    {
      key: "locale_products_46json_8a4797e0",
      load: () => Promise.resolve(locale_products_46json_8a4797e0),
      cache: true
    },
    {
      key: "locale_gdpr_46json_6fe176b0",
      load: () => Promise.resolve(locale_gdpr_46json_6fe176b0),
      cache: true
    },
    {
      key: "locale_giftCardsPage_46json_6494f13b",
      load: () => Promise.resolve(locale_giftCardsPage_46json_6494f13b),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_BookingFormComponents_46json_1da4f8c5",
      load: () => Promise.resolve(locale_BookingFormComponents_46json_1da4f8c5),
      cache: true
    },
    {
      key: "locale_ExpandableText_46json_ea0c6621",
      load: () => Promise.resolve(locale_ExpandableText_46json_ea0c6621),
      cache: true
    },
    {
      key: "locale_ModalVykradeni2_46json_d1bd3696",
      load: () => Promise.resolve(locale_ModalVykradeni2_46json_d1bd3696),
      cache: true
    },
    {
      key: "locale_SectionPricing_46json_51f08b8e",
      load: () => Promise.resolve(locale_SectionPricing_46json_51f08b8e),
      cache: true
    },
    {
      key: "locale_SectionServices_46json_d0eeff76",
      load: () => Promise.resolve(locale_SectionServices_46json_d0eeff76),
      cache: true
    },
    {
      key: "locale_TheFooter_46json_5c91eaab",
      load: () => Promise.resolve(locale_TheFooter_46json_5c91eaab),
      cache: true
    },
    {
      key: "locale_TheHeader_46json_ab33f711",
      load: () => Promise.resolve(locale_TheHeader_46json_ab33f711),
      cache: true
    },
    {
      key: "locale_indexPage_46json_4d55f150",
      load: () => Promise.resolve(locale_indexPage_46json_4d55f150),
      cache: true
    },
    {
      key: "locale_nuslePage_46json_84c28f0a",
      load: () => Promise.resolve(locale_nuslePage_46json_84c28f0a),
      cache: true
    },
    {
      key: "locale_zizkovPage_46json_85f0a4d3",
      load: () => Promise.resolve(locale_zizkovPage_46json_85f0a4d3),
      cache: true
    },
    {
      key: "locale_sluzbyPage_46json_57c4b699",
      load: () => Promise.resolve(locale_sluzbyPage_46json_57c4b699),
      cache: true
    },
    {
      key: "locale_errorPage_46json_c76f7484",
      load: () => Promise.resolve(locale_errorPage_46json_c76f7484),
      cache: true
    },
    {
      key: "locale_teamData_46json_abd8810e",
      load: () => Promise.resolve(locale_teamData_46json_abd8810e),
      cache: true
    },
    {
      key: "locale_products_46json_122c7ed6",
      load: () => Promise.resolve(locale_products_46json_122c7ed6),
      cache: true
    },
    {
      key: "locale_gdpr_46json_92247e5d",
      load: () => Promise.resolve(locale_gdpr_46json_92247e5d),
      cache: true
    },
    {
      key: "locale_giftCardsPage_46json_812e0e41",
      load: () => Promise.resolve(locale_giftCardsPage_46json_812e0e41),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "cs",
      name: "Česky",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/BookingFormComponents.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/ExpandableText.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/ModalVykradeni2.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/SectionPricing.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/SectionServices.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/TheFooter.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/TheHeader.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/indexPage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/nuslePage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/zizkovPage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/sluzbyPage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/errorPage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/teamData.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/products.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/gdpr.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/cs/giftCardsPage.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/en/BookingFormComponents.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/ExpandableText.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/ModalVykradeni2.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/SectionPricing.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/SectionServices.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/TheFooter.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/TheHeader.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/indexPage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/nuslePage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/zizkovPage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/sluzbyPage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/errorPage.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/teamData.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/products.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/gdpr.json",
          cache: undefined
        },
        {
          path: "/opt/buildhome/repo/i18n/locales/en/giftCardsPage.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "cs",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "cs",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    sluzby: {
      cs: "/sluzby",
      en: "/services"
    },
    gdpr: {
      cs: "/gdpr",
      en: "/gdpr"
    },
    terms: {
      cs: "/obchodni-podminky",
      en: "/terms-and-conditions"
    },
    complaints: {
      cs: "/reklamacni-podminky",
      en: "/complaints-and-returns"
    },
    "delivery-payment": {
      cs: "/dodaci-a-platebni-podminky",
      en: "/delivery-and-payment"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "cs",
    name: "Česky",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/BookingFormComponents.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/ExpandableText.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/ModalVykradeni2.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/SectionPricing.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/SectionServices.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/TheFooter.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/TheHeader.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/indexPage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/nuslePage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/zizkovPage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/sluzbyPage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/errorPage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/teamData.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/products.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/gdpr.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/cs/giftCardsPage.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/en/BookingFormComponents.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/ExpandableText.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/ModalVykradeni2.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/SectionPricing.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/SectionServices.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/TheFooter.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/TheHeader.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/indexPage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/nuslePage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/zizkovPage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/sluzbyPage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/errorPage.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/teamData.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/products.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/gdpr.json",
        cache: undefined
      },
      {
        path: "/opt/buildhome/repo/i18n/locales/en/giftCardsPage.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/